import React, { useState, useEffect } from "react";
import { Tabs, Search, Table,Select} from "@veneer/core";
import ConnectAPI from "../../services/api";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import moment from "moment";


const Evergreentables=(props) =>{
    const { t } = useTranslation();
    const connectApi = new ConnectAPI();
    const [activeTabIndex, setactiveTabIndex] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [evergeenactive, setevergeenactive]=useState([]);
    const [evergeeninactive,setevergeeninactive]=useState([]);
    const [evergreen,setevergreen]=useState([]);
    const [pageSize, setPageSize] = useState(15);
    const [selectStartDate, setselectStartDate]=useState([]);
    const [selectStartDate_in, setselectStartDate_in]=useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChange = (page) => setCurrentPage(page);
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
    const selectTab = (event) => (index) => {
        setactiveTabIndex(index);
    };


    useEffect(()=>{
        //validate location
        let currentUser = JSON.parse(localStorage.getItem("currentUser"));
        let validate=false;
        currentUser.urls.forEach(ur=>{
            if (ur==window.location.pathname){
                validate=true;
            }
        });
        if (validate==false){
            const { history } = props;
            history.push({
                pathname: '/' 
            });
        }
        //end validate
        start();
    },[]);
    const start = async () => {
        connectApi.get("api/Channels/getevergreentables", "",fetchtables)
        .catch ((error) => {
            setIsLoading(false);
            Swal.fire(
                "Error " + error?.response?.status,
                error?.response?.data,
                "error"
            );
        });
        setIsLoading(true);
    }
    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }
    const formatDateOptions = dates => dates.map(date => ({ value: date, label: date }));
    const fetchtables = (status, data) => {
        var ActiveTable=data.scGrouped.filter(item => {
            return moment(data.monthyear).isBetween(item.startDate,item.endDate)
        });
        var inActiveTable=data.scGrouped.filter(item => {
            return !moment(data.monthyear).isBetween(item.startDate,item.endDate)
        });
        var result=sort(ActiveTable, "ascending", "startDate").map(item=>item.startDate).filter(onlyUnique);
        var result2=sort(inActiveTable, "ascending", "startDate").map(item=>item.startDate).filter(onlyUnique);
        setselectStartDate(formatDateOptions(result));
        setselectStartDate_in(formatDateOptions(result2));

        setevergeenactive(ActiveTable);
        setevergeeninactive(inActiveTable);
        setevergreen(data.scGrouped);
    }
    function sort(array, orderBy, orderType) { 
        return array.sort((a, b) => {
        const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy)
            : -descendingComparator(a, b, orderBy);
    
        return value;
        });
    }
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        
        
        if (orderBy=="idSpecialCondition"){
        if (parseInt(bSort) < parseInt(aSort)) {
            return -1;
        }
        if (parseInt(bSort) > parseInt(aSort)) {
            return 1;
        }
        }else if(orderBy=="startDate" || orderBy=="endDate"){
        if (Date.parse(bSort) < Date.parse(aSort)) {
            return -1;
        }
        if (Date.parse(bSort) > Date.parse(aSort)) {
            return 1;
        }
        }else{
        if (bSort < aSort) {
            return -1;
        }
        if (bSort > aSort) {
            return 1;
        }
        }
        
        return 0;
    }
    function filter(array, filters) {
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
        const filterValue = filters[value];
        const filter = typeof filterValue === 'object' ? filterValue[0] : filterValue;
        if (filter) {
            arrayFiltered = arrayFiltered.filter((a) => {
            const aUpper = a[value] && a[value].toString().toUpperCase();
            const filterUpper = filter && filter.toString().toUpperCase();
            return aUpper.indexOf(filterUpper) > -1;
            });
        }
        });
        return arrayFiltered;
    }
    const ActiveTables=()=>{
        
        const [customFilterValue, setCustomFilterValue] = useState('');
        const [enduserFilterValue,setenduserFilterValue]=useState('');
        const [pressFilterValue, setpressFilterValue]=useState('');
        const [selectedvalue_start, setselectedvalue_start]=useState([]);
        const ConfigColumns = [
            {
                id: 'customerName',
                label: t('customerName'),
                filter: (
                <Search
                    id="customer-search"
                    value={customFilterValue}
                    onChange={(value) => setCustomFilterValue(value)}
                    
                />
                )
            },
            {
                id: 'endUserName',
                label: t('endUserName'),
                filter: (
                <Search
                    id="Eneduser-search"
                    value={enduserFilterValue}
                    onChange={setenduserFilterValue}
                />
                )
            },
            {
                id:"startDate",
                label: t('specialcondition.startdate'),
                filter:(
                <Select
                    id="table-filter-startdate"
                    options={selectStartDate}
                    onChange={(value)=>{
                    setselectedvalue_start([value.value])
                    }}
                    onClear={() => setselectedvalue_start([])}
                    value={selectedvalue_start}
                />
                )
            },
            {
                id:"idPress",
                label: t('pressid'),
                filter: (
                <Search
                    id="Press-search"
                    value={pressFilterValue}
                    onChange={setpressFilterValue}
                />
                )
            }
        ];
        const [orderBy, setOrderBy] = useState('name');
        const [orderType, setOrderType] = useState('ascending');
        const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
        const [orderActive, setOrderActive] = useState(
            ConfigColumns.map((c) => c.id)
        );
        const handleOnColumnReorder = (newOrder) => {
            setOrderActive(newOrder);
            setOrder(newOrder);
        };
        
        let filteredData=filter(evergeenactive,
            {
                customerName: customFilterValue, 
                endUserName: enduserFilterValue, 
                idPress:pressFilterValue ,
                startDate:selectedvalue_start
            }
        );
        let pagdata = sort(filteredData, orderBy, orderType).slice(
            (currentPage - 1) * pageSize,
            (currentPage - 1) * pageSize + pageSize
        );
        const handleSort = (_, { id, type }) => {
            setOrderBy(id);
            setOrderType(type);
        };
        return (<>
            <Table  
                columns={ConfigColumns}
                data={pagdata}
                showFilters
                columnReorder
                onColumnReorder={handleOnColumnReorder}
                onSort={handleSort}
                //loading={isLoading}
                preferences={{
                defaultOrder: ConfigColumns.map((c) => c.idSpecialCondition),
                order,
                sortBy: {
                    id: orderBy,
                    type: orderType,
                },
                width: [
                    {
                    columnId: 'idSpecialCondition', width: 150
                    },
                    {
                    columnId: 'specialConditionType', width: 150
                    },
                    {
                    columnId: 'customerName', width: 230
                    },
                    {
                    columnId: 'endUserName', width: 230
                    },
                    
                    {
                    columnId: 'startDate', width: 150
                    },
                    {
                    columnId: 'endDate', width: 150
                    },
                    {
                    columnId: 'idPress', width: 230
                    },
                ]
                }}
                pagination={{
                currentPage,
                onPageChange: handlePageChange,
                pageSize,
                totalItems: filteredData.length,
                }}
            />
        </>)
    }
    const InactiveTables=()=>{
        const [customFilterValuein, setCustomFilterValuein] = useState('');
        const [enduserFilterValuein,setenduserFilterValuein]=useState('');
        const [pressFilterValuein, setpressFilterValuein]=useState('');
        const [selectedvalue_startin, setselectedvalue_startin]=useState([]);
        const ConfigColumns = [
            {
                id: 'customerName',
                label: t('customerName'),
                filter: (
                <Search
                    id="customer-search"
                    value={customFilterValuein}
                    onChange={(value) => setCustomFilterValuein(value)}
                    
                />
                )
            },
            {
                id: 'endUserName',
                label: t('endUserName'),
                filter: (
                <Search
                    id="Eneduser-search"
                    value={enduserFilterValuein}
                    onChange={setenduserFilterValuein}
                />
                )
            },
            {
                id:"startDate",
                label: t('specialcondition.startdate'),
                filter:(
                <Select
                    id="table-filter-startdate"
                    options={selectStartDate}
                    onChange={(value)=>{
                    setselectedvalue_startin([value.value])
                    }}
                    onClear={() => setselectedvalue_startin([])}
                    value={selectedvalue_startin}
                />
                )
            },
            {
                id:"idPress",
                label: t('pressid'),
                filter: (
                <Search
                    id="Press-search"
                    value={pressFilterValuein}
                    onChange={setpressFilterValuein}
                />
                )
            }
        ];
        const [orderBy, setOrderBy] = useState('name');
        const [orderType, setOrderType] = useState('ascending');
        const [order, setOrder] = useState(ConfigColumns.map((c) => c.id));
        const [orderActive, setOrderActive] = useState(
            ConfigColumns.map((c) => c.id)
        );
        const handleOnColumnReorder = (newOrder) => {
            setOrderActive(newOrder);
            setOrder(newOrder);
        };
        
        let filteredData=filter(evergeeninactive,
            {
                customerName: customFilterValuein, 
                endUserName: enduserFilterValuein, 
                idPress:pressFilterValuein ,
                startDate:selectedvalue_startin
            }
        );
        let pagdata = sort(filteredData, orderBy, orderType).slice(
            (currentPage - 1) * pageSize,
            (currentPage - 1) * pageSize + pageSize
        );
        const handleSort = (_, { id, type }) => {
            setOrderBy(id);
            setOrderType(type);
        };
        return (<>
            <Table  
                columns={ConfigColumns}
                data={pagdata}
                showFilters
                columnReorder
                onColumnReorder={handleOnColumnReorder}
                onSort={handleSort}
                //loading={isLoading}
                preferences={{
                defaultOrder: ConfigColumns.map((c) => c.idSpecialCondition),
                order,
                sortBy: {
                    id: orderBy,
                    type: orderType,
                },
                width: [
                    {
                    columnId: 'idSpecialCondition', width: 150
                    },
                    {
                    columnId: 'specialConditionType', width: 150
                    },
                    {
                    columnId: 'customerName', width: 230
                    },
                    {
                    columnId: 'endUserName', width: 230
                    },
                    
                    {
                    columnId: 'startDate', width: 150
                    },
                    {
                    columnId: 'endDate', width: 150
                    },
                    {
                    columnId: 'idPress', width: 230
                    },
                ]
                }}
                pagination={{
                currentPage,
                onPageChange: handlePageChange,
                pageSize,
                totalItems: filteredData.length,
                }}
            />
        </>)
    }
    const NewTable=()=>{
        return (<>
            Panel 333
        </>)
    }
    return (<>
        <Tabs
        controlId="default"
        onChangeTab={selectTab()}
        selectedTabId={activeTabIndex}
        tabs={[
            { id: 0, label: t("active"), content: <div style={{ padding: '30px' }}><ActiveTables/></div> },
            { id: 1, label: t("inactive"), content: <div style={{ padding: '30px' }}><InactiveTables/></div> },
            { id: 2, label: 'New', content: <div style={{ padding: '30px' }}><NewTable/></div> },
        ]}
        />
    </>)
}

export default Evergreentables;